import { NextPage } from 'next'
import { useEventQuery } from 'graphql/generated'
import ErrorMessage from 'components/ErrorMessage'
import NavbarLayout from 'components/NavbarLayout'
import { EventProvider } from 'context/EventContext'
import Event from 'components/events/Event'
import genGetServerSideProps, {
  IEventPageProps
} from 'lib/getServerSideProps/forEventPage'
import ScreenLayout from 'components/ScreenLayout'
import { CollectiveProvider } from 'context/CollectiveContext'

const EventPage: NextPage<IEventPageProps> = ({ eventId }) => {
  const { data, error } = useEventQuery({
    fetchPolicy: 'cache-and-network',
    variables: { id: eventId },
    skip: !eventId
  })
  const event = data?.event

  if (!event) {
    return <NavbarLayout stuckClasses="bg-gray-100" />
  }

  const content = (
    <NavbarLayout stuckClasses="bg-gray-100">
      <EventProvider event={event}>
        <ScreenLayout
          layout={event.collective ? 'collective' : 'generic_sidebar'}
        >
          {!!error && (
            <ErrorMessage
              message={`We couldn't load this Event right now. Please try again later.`}
            />
          )}

          <Event />
        </ScreenLayout>
      </EventProvider>
    </NavbarLayout>
  )

  if (!event?.collective) {
    return content
  }

  return (
    <CollectiveProvider collectiveId={event.collective.id}>
      {content}
    </CollectiveProvider>
  )
}

export default EventPage

export const getServerSideProps = genGetServerSideProps()
